
<div class="modal active preProcessingTool">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Pre Processing Tool Import menu</h2>
      <div class="close" (click)="cancelPreProcessingTool()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngPreProcessingToolForm" #ngForm="ngForm" id="preProcessingToolForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Flight Inspection File Source</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">File Name</label>
                  <input
                  style="padding-left: 0px;"
                  maxlength="300"
                  type="file"
                  name="filename"
                  id="filename"
                  #uploadCsvFile
                  [(ngModel)]="this.file"
                />
                </div>
                <div><input id="Decimate" name="decimate" type="checkbox" [checked]="decimate" (change)="changeDecimate()"/><label for="">Decimate</label></div>
                <div><input [disabled]="!decimate" type="text" /><label for="">One sample by each</label></div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Layer Settings</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div><label for="">Layer Name</label><input type="text" [disabled]="uploadCsvFile.value ? false : true" [value]="uploadCsvFile.value.split('\\').pop()"/></div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Configured Fields to Import</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for=""></label>
                  <div class="btn">
                    <button [disabled]="uploadCsvFile.value ? false : true">Configure Flight Inspection Format</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" [disabled]="!ngForm.form.valid">
              Save
            </button>
            <button class="gray" (click)="cancelPreProcessingTool()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
